import { Avatar, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import * as api from "api/Knowledge";
import BoxDrawer from 'components/BoxDrawer';
import { SpinnerIndicator } from 'components/CallServer';
import IconCheckCircle from 'components/Icons/IconCheckCircle';
import IconTimesCircle from 'components/Icons/IconTimesCircle';
import MuiMessageBox from 'components/MuiExtras/MessageBox/MuiMessageBox';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import ApprovalStatusName from 'components/Translations/ApprovalStatusName';
import { ApprovalStatus } from 'models/ApiEnums';
import { WorkFlowStepDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: WorkFlowStepDto[];
    loading: boolean;
}

interface IProps {
    publicationId: string;
    onClose: () => void;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////


class WorkFlowDrawer extends React.PureComponent<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        };
    }

    private loadData() {
        api.getWorkflowSteps(this.props.publicationId)
            .then((data) => {
                this.setState({ data, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    componentDidMount() {
        this.loadData();
    }

    private renderData() {
        const { data } = this.state;

        if (data == null) {
            return <MuiMessageBox variant="error" message={this.props.t("Views.Timeline.Dialogs.WorkFlowDrawer.LoadError")} />;
        }

        return (
            <List dense disablePadding>
                {
                    data.map((v, index) => {
                        var primary = v.status == ApprovalStatus.Approved
                            ? <MuiColor variant="success"><IconCheckCircle color="inherit" /> <ApprovalStatusName approvalStatus={v.status} /></MuiColor>
                            : v.status == ApprovalStatus.Rejected
                                ? <MuiColor variant="error"><IconTimesCircle color="inherit" /> <ApprovalStatusName approvalStatus={v.status} /></MuiColor>
                                : <MuiColor variant="warning"><IconCheckCircle color="inherit" /> <ApprovalStatusName approvalStatus={v.status} /></MuiColor >;

                        return (
                            <ListItem key={index}>
                                <ListItemAvatar>
                                    <Avatar src={v.approver.thumbnailUrl} title={v.approver.name} />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={primary}
                                    secondary={v.notes}

                                />
                            </ListItem>
                        );
                    })
                }
            </List>
        );
    }

    public render() {
        const { loading } = this.state;
        const { onClose } = this.props;

        return (
            <BoxDrawer
                open
                title={this.props.t("Views.Timeline.Dialogs.WorkFlowDrawer.BoxTitle")}
                onClose={() => { onClose(); }}
            >
                <MuiPaper dense elevation={0}>
                    {
                        loading
                            ? <SpinnerIndicator />
                            : this.renderData()
                    }
                </MuiPaper>
            </BoxDrawer>
        );
    }
}

export default withTranslation()(WorkFlowDrawer);